import { api } from './client';

export interface SDNotification {
  id: string;
  user_id: string;
  ticket_id: string | null;
  kind: string;
  title: string;
  body: string;
  severity: 'info' | 'warn' | 'critical';
  created_at: string;
  read_at: string | null;
}

export const notifsApi = {
  list: (unread_only = false) =>
    api.get<SDNotification[]>('/api/v1/notifications', { params: { unread_only } }).then(r => r.data),
  unreadCount: () =>
    api.get<{ count: number }>('/api/v1/notifications/unread_count').then(r => r.data.count),
  markRead: (id: string) =>
    api.post<SDNotification>(`/api/v1/notifications/${id}/read`).then(r => r.data),
  markAllRead: () =>
    api.post('/api/v1/notifications/read_all'),
};
